/**
 * 图片轮播器
 */
const header = {
  namespaced: true,
  state: {
    foilerSlug: "shshsh",
    imgSlug: "",
    type: "all",
    postsPerPage: 80,
    catlang: '',
    catChild: '',
    isNavShow: false,
    getFavoritesList: [],
    isShowFavoritesList: true,
    getFavoritesNum: 1,
    tagName: '',
    tagShow: false
  },
  action: {},
  mutations: {
    updateFoilerSlug(state, slug) {
      state.foilerSlug = slug;
    },
    updateImgSlug(state, slug) {
      state.imgSlug = slug;
    },
    updateType(state, all) {
      state.type = all;
    },
    updatePostsPePage(state, pageAll) {
      state.postsPerPage = pageAll;
    },
    updateCatlang(state, lang) {
      state.catlang = lang;
    },
    updateCatChild(state, child) {
      state.catChild = child;
    },
    
    updateisNavShow(state, isShow) {
      state.isNavShow = isShow;
    },
    updateisGetFavoritesList(state, list) {
      state.getFavoritesList = list;
    },
    updateisShowFavoritesList(state, isShow) {
      state.isShowFavoritesList = isShow;
    },
    updategetFavoritesNum(state, num) {
      state.getFavoritesNum = num;
    },
    updateTagName(state, tag) {
      state.tagName = tag;
    },
    updateTagShow(state, show) {
      state.tagShow = show;
    },
  }
};

export default header;